import eimg1 from '../images/events/event1.jpg'
import eimg2 from '../images/events/event2.jpg'
import eimg3 from '../images/events/event3.jpg'
import eimg4 from '../images/events/event4.jpg'
import esImg from '../images/event-single/fashion1.jpg'
import esImg2 from '../images/event-single/fashion2.jpg'

const Events = [
    {
        id: '1',
        eImg:eimg3,
        date:<><p style={{ marginTop: "15px" }}>
            <a
                href="https://gofund.me/c5f86e480"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    color: "#d62828",
                    fontWeight: "bold",
                    textDecoration: "none",
                    border: "2px solid #d62828",
                    padding: "8px 14px",
                    borderRadius: "6px",
                    transition: "all 0.3s ease",
                }}
                onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#d62828";
                    e.currentTarget.style.color = "#fff";
                }}
                onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#d62828";
                }}
            >
                DONATE NOW →
            </a>
        </p>
        </>,
        eTitle:"Donate to Hurricane Melissa Relief!",
        slug: 'Providing-Hurricane-Relief',
        dec:<>
            <p><h2>Bringing Hope to Westmoreland, Jamaica - Together with Love</h2></p>
            <p>In the wake of <strong>Hurricane Melissa</strong>, the people of <strong>Westmoreland, Jamaica</strong> are facing unimaginable loss - homes destroyed, schools damaged, and families struggling to meet their most basic needs. But through compassion and unity, we can bring light back to those in the shadows of this storm.</p>
            <p>The <strong>Love of Hearts Foundation Inc.</strong> is stepping forward to provide urgent relief and recovery support - from food, water, and hygiene supplies to school materials and household essentials. Every donation, no matter how small, becomes a seed of hope in the lives of those rebuilding from the ground up.</p>
            <p>This is more than a relief effort - it’s a movement of love. Together, we can help restore dignity, stability, and faith in a brighter tomorrow.</p>
            <p><h1>Support Jamaica. Support Hope. Support Each Other. Donate today and help us make love tangible again.</h1></p>
            <p style={{ marginTop: "15px" }}>
                <a
                    href="https://gofund.me/c5f86e480"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        color: "#d62828",
                        fontWeight: "bold",
                        textDecoration: "none",
                        border: "2px solid #d62828",
                        padding: "8px 14px",
                        borderRadius: "6px",
                        transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = "#d62828";
                        e.currentTarget.style.color = "#fff";
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.color = "#d62828";
                    }}
                >
                    DONATE NOW →
                </a>
            </p>
        </>,
        width: "650px",
        height: "687px",
        startTime: "",
        endTime: "",
        address: "",
        organization: "Love of Harts Foundation Inc.",
        contact: "info@loveofheartsfoundation.org",
        eventImages: [],
        imagesPerRow: 0,
    },
    {
        id: '4',
        eImg:eimg4,
        date:<>
            <p>For Relief - Opened 29 Oct, 2025 for donations. Bringing Hope to Westmoreland, Jamaica - Together with Love</p>
            <p style={{ marginTop: "15px" }}>
                <a
                    href="https://gofund.me/c5f86e480"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        color: "#d62828",
                        fontWeight: "bold",
                        textDecoration: "none",
                        border: "2px solid #d62828",
                        padding: "8px 14px",
                        borderRadius: "6px",
                        transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = "#d62828";
                        e.currentTarget.style.color = "#fff";
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.color = "#d62828";
                    }}
                >
                    DONATE NOW →
                </a>
            </p>
        </>,
        eTitle:"Providing Relief for Westmoreland, Jamaica after Hurricane Melissa!",
        slug: 'Donate-Now',
        dec:<>
            <p><h2>Bringing Hope to Westmoreland, Jamaica - Together with Love</h2></p>
            <p>In the wake of <strong>Hurricane Melissa</strong>, the people of <strong>Westmoreland, Jamaica</strong> are facing unimaginable loss - homes destroyed, schools damaged, and families struggling to meet their most basic needs. But through compassion and unity, we can bring light back to those in the shadows of this storm.</p>
            <p>The <strong>Love of Hearts Foundation Inc.</strong> is stepping forward to provide urgent relief and recovery support - from food, water, and hygiene supplies to school materials and household essentials. Every donation, no matter how small, becomes a seed of hope in the lives of those rebuilding from the ground up.</p>
            <p>This is more than a relief effort - it’s a movement of love. Together, we can help restore dignity, stability, and faith in a brighter tomorrow.</p>
            <p><h1>Support Jamaica. Support Hope. Support Each Other. Donate today and help us make love tangible again.</h1></p>
            <p style={{ marginTop: "15px" }}>
                <a
                    href="https://gofund.me/c5f86e480"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        color: "#d62828",
                        fontWeight: "bold",
                        textDecoration: "none",
                        border: "2px solid #d62828",
                        padding: "8px 14px",
                        borderRadius: "6px",
                        transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = "#d62828";
                        e.currentTarget.style.color = "#fff";
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.color = "#d62828";
                    }}
                >
                    DONATE NOW →
                </a>
            </p>
        </>,
        width: "650px",
        height: "3687px",
        startTime: "",
        endTime: "",
        address: "",
        organization: "Love of Harts Foundation Inc.",
        contact: "info@loveofheartsfoundation.org",
        eventImages: [],
        imagesPerRow: 0,
    },
    {
        id: '2',
        eImg:eimg2,
        date:"21 Jun, 2025",
        eTitle: 'Dress for Love: A Charity Pop-Up Event',
        slug: 'Help-Children',
        dec:<><p>Join us for “Dress for Love,” a heartfelt charity pop-up event presented by Love of Hearts Foundation Inc. in collaboration with Styled by Bron’tai. This fashion-forward community initiative invites you to shop for a cause — every purchase directly supports programs that empower lives through education and financial assistance.</p>
            <p> Discover affordable, stylish clothing for men, women, and children, with prices starting at just $5, $10, and $20. Your participation helps fund educational opportunities for children, teens, and young adults, as well as financial assistance for women in need.</p>
            <p>Come out, shop, and make a difference while enjoying a fun and meaningful day of fashion and philanthropy.</p></>,
        width: "650px",
        height: "687px",
        startTime: "9AM",
        endTime: "7PM",
        address: "",
        organization: "Love of Harts Foundation Inc.",
        contact: "info@loveofheartsfoundation.org",
        eventImages: [esImg,esImg2],
        imagesPerRow: 2,
    },
    {
        id: '3',
        eImg:eimg1,
        date:"28 Jun, 2025",
        eTitle: 'Yaad Style Cuisine',
        slug: 'Help-The-Poor',
        dec:'Proceeds in aid of our annual Back-to-School charity event.',
        width: "650px",
        height: "687px",
        startTime: "9AM",
        endTime: "7PM",
        address: "6314 Magnolia Trails Lane, Gibsonton, Florida 33534",
        organization: "Love of Harts Foundation Inc.",
        contact: "info@loveofheartsfoundation.org"
    },
]

export default Events;